import styled from '@emotion/styled'

import { Space, Typography } from '@/components/core-v2'

type DataRowBorderPosition = 'top' | 'bottom' | 'both'

const StyledDataRowWrapper = styled.div<{ highlighted: boolean; position?: DataRowBorderPosition }>`
  ${props => {
    const style = `solid 1px var(--White90)`
    let result = ''

    if (props.position === 'top') {
      result = `border-top: ${style};`
    } else if (props.position === 'bottom') {
      result = `border-bottom: ${style};`
    } else if (props.position === 'both') {
      result = `border-top: ${style}; border-bottom: ${style};`
    }

    return result
  }}
  background: ${props => (props.highlighted ? 'var(--InfoBG)' : 'transparent')};
  width: 100%;
`

export const ProposedChangesDataRow = ({
  borderPosition,
  currentValue,
  highlighted = false,
  propertyName
}: {
  borderPosition?: DataRowBorderPosition
  currentValue: string | number | boolean | undefined
  highlighted?: boolean
  propertyName: string
}) => (
  <StyledDataRowWrapper
    aria-label={highlighted ? 'Changed data row' : 'Data row'}
    highlighted={highlighted}
    position={borderPosition}
  >
    <Space isflex justifyContent="space-between" p={4}>
      <Typography fontSize="13px" fontWeight={highlighted ? 'bold' : 'normal'} variant="b3">
        {propertyName}
      </Typography>
      <Typography fontSize="13px" fontWeight={highlighted ? 'bold' : 'normal'} variant="b3">
        {currentValue}
      </Typography>
    </Space>
  </StyledDataRowWrapper>
)
